import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import Sidebar from './Sidebar';
import {
  userLogout,
  getThemeColor,
  getThemeColorNumber,
  storeThemeColor,
  storeThemeColorNumber,
} from '../common/globals';
import { signout } from '../utils/utils';
import withLoader from '../common/withLoader';
import withNotify from '../common/withNotify';
import withCalendarFilter from '../common/withCalendarFilter';
import withUser from '../common/withUser';
import withFirstLoginSessionToken from '../common/withFirstLoginSessionToken';
import {
  deleteDb,
  getNotSyncdCases,
} from '../utils/db';
import Bugsnag from '../helpers/bugsnag';
import withScanInventoryScanner from '../common/withScanInventoryScanner';
import withCaseDer from '../common/withCaseDer';
import withOnline from '../common/withOnline.js';
import withNotifications from '../common/withNotifications.js';
import FileExcelIcon from '../assets/images/file-excel-outline.svg';
import AscIcon from '../assets/images/asc.png';
import DescIcon from '../assets/images/desc.png';
import BellIcon from '../assets/images/bell.png';
import AddCaseIcon from '../assets/images/icon-card-plus-outline.png';
import WebGoIcon from '../assets/images/web_go.png';
import withThemeColor from '../common/withThemeColor.js';

class Header extends Component {
  _onLogout = async () => {
    try {
      const {
        setLoader, setCalendarFilter, setFirstLoginSessionToken, setScanInventoryScanner
      } = this.props;

      const color = await getThemeColor();
      const colorNumber = await getThemeColorNumber();

      setLoader(true);
      const getNotSyncedCases = await getNotSyncdCases();
      setCalendarFilter({});
      setFirstLoginSessionToken('');
      setScanInventoryScanner({});
      signout().then(async () => {
        if (getNotSyncedCases !== undefined && !getNotSyncedCases.length > 0) {
          await deleteDb();
          window.localStorage.clear();
          await storeThemeColor(color);
          await storeThemeColorNumber(colorNumber);
        }
        await userLogout();
        setLoader(false);
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickNotifications = () => {
    try {
      const { online, notify } = this.props;
      if (online) {
        if (window.location.pathname === '/notifications' && window.$('.left-bar').hasClass('is-active')) {
          window.$('.left-bar').removeClass('is-active');
          browserHistory.push('/notifications');
        } else {
          browserHistory.push('/notifications');
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view notifications.', time: 5 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      sideMenu = false,
      title = '',
      goBack = '',
      goForward = {},
      actionButton = false,
      logout = false,
      actionButtonExtra = {},
      user: {
        territories
      },
      caseDer,
      customRightSide,
      notifications,
      showRighIcon,
      actionRighIcon,
      actionCaseHisterButton = {},
      themeColor,
    } = this.props;

    return (
      <>
        <div className="site-wrapper top-bar sticky-top">
          <header className="site-header">
            <div className="container">
              <div className="row gx-0">
                <div className="col">
                  {
                    sideMenu
                      ? (
                        <div>
                          <button className="btn navbar-toggle me-10" style={{ position: 'relative' }} type="button">
                            <i className="fas fa-bars" />
                            {/* {notifications.totalUnread ? (
                              <span className="notification-circle" />
                            ) : null} */}
                          </button>

                          <Link className="btn-link sub-header-text cursor-pointer search-box" onClick={this._onClickNotifications}>
                            <img
                              className="optimize-icon"
                              src={BellIcon}
                              alt="bell-icon"
                            />
                            {notifications.totalUnread ? (
                              <span className="notification-circle" />
                            ) : null}
                          </Link>
                        </div>
                      )
                      : ((goBack !== '' || (goBack !== undefined && goBack.length >= 1))
                        && ((territories !== undefined && territories.length > 1) || (title !== 'Teams')))
                        ? (
                          <Link className="btn-link sub-header-text cursor-pointer" onClick={goBack === '' ? () => { } : goBack}>
                            <i className="fas fa-chevron-left ms-0 me-1" />
                            {(caseDer === 'true' || caseDer === '') ? 'Back'
                              : ((caseDer === 'false' || caseDer === 'true' || caseDer === '') && title === 'View DER')
                                ? 'Back' : (title === 'Edit DER' || title === 'Copy DER' || title === 'Create DER') ? 'Back' : 'Exit'}
                          </Link>
                        )
                        : (logout || (territories !== undefined && territories.length === 1 && (title === 'Teams' || title === ''))) ? (
                          <button className="btn header-btn sub-header-text" onClick={this._onLogout}>
                            Log Out
                          </button>
                        ) : null
                  }
                </div>
                <div className={`${sideMenu ? 'col' : 'col-6'}`}>
                  {
                    title === ''
                      ? (
                        <div className="logo">
                          <Link to="/manage-cases">
                            {
                              themeColor === 'light'
                                ? (
                                  <img
                                    src="/assets/images/dark_report_logo.png" alt="logo"
                                    onError={(event) => {
                                      event.target.src = '/assets/images/dark_report_logo.png';
                                      event.onerror = null;
                                    }}
                                  />
                                )
                                : (
                                  <img
                                    src="/assets/images/white_report_logo.png" alt="logo"
                                    onError={(event) => {
                                      event.target.src = '/assets/images/white_report_logo.png';
                                      event.onerror = null;
                                    }}
                                  />
                                )
                            }
                          </Link>
                        </div>
                      )
                      : <p>{title}</p>
                  }
                </div>
                <div className="col text-end">
                  {
                    Object.keys(goForward).length > 0
                      ? typeof goForward.showIcon !== 'undefined' && goForward.showIcon
                        ? (
                          goForward.siteFlag !== 'undefined' && goForward.siteFlag
                            ? (
                              <Link
                                className="btn-link sub-header-text cursor-pointer"
                                to={goForward.url && goForward.url}
                                target="_blank"
                              >
                                <img width="28px" alt="Web Go" src={WebGoIcon} />
                              </Link>
                            ) : (
                              <Link
                                className="btn-link sub-header-text cursor-pointer"
                                to={goForward.url && goForward.url}
                                onClick={() => goForward.onGoForward()}
                              >
                                <img width="28px" alt="Add Case" src={AddCaseIcon} />
                              </Link>
                            )
                        )
                        : (
                          <Link
                            className="btn-link sub-header-text cursor-pointer"
                            to={goForward.url && goForward.url}
                            dangerouslySetInnerHTML={{ __html: goForward.title }}
                            onClick={() => goForward.onGoForward()}
                          />
                        )
                      : Object.keys(actionButton).length
                        ? (
                          <button
                            className="btn header-btn sub-header-text btn-dgr"
                            type={actionButton.type ? actionButton.type : 'submit'}
                            onClick={actionButton.onClick && actionButton.onClick}
                          >
                            {actionButton.title}
                          </button>
                        )
                        : null
                  }
                  {
                    Object.keys(actionButtonExtra).length
                      ? (
                        <button
                          className="btn header-btn sub-header-text btn-ml"
                          type={actionButtonExtra.type ? actionButtonExtra.type : 'submit'}
                          onClick={actionButtonExtra.onClick && actionButtonExtra.onClick}
                        >
                          {actionButtonExtra.title}
                        </button>
                      )
                      : null
                  }
                  {
                    customRightSide || null
                  }
                  {
                    showRighIcon
                      ? (
                        <Link onClick={actionRighIcon} className="btn-link sub-header-text cursor-pointer">
                          <img
                            className="optimize-icon"
                            src={FileExcelIcon}
                            alt="file-icon"
                          />
                        </Link>
                      )
                      : ''
                  }
                  {
                    Object.keys(actionCaseHisterButton).length
                      ? (
                        <Link onClick={actionCaseHisterButton.onClick} className="btn-link sub-header-text cursor-pointer">
                          {
                            actionCaseHisterButton.orderFlag
                              ? (
                                <img
                                  className="optimize-icon"
                                  src={AscIcon}
                                  alt="file-icon"
                                />
                              )
                              : (
                                <img
                                  className="optimize-icon"
                                  src={DescIcon}
                                  alt="file-icon"
                                />
                              )
                          }
                        </Link>
                      )
                      : ''
                  }
                </div>
              </div>
            </div>
          </header>
          <Sidebar
            sideMenu={sideMenu}
            totalUnread={notifications.totalUnread}
          />
        </div>
      </>
    );
  }
}

export default withNotifications(
  withOnline(
    withScanInventoryScanner(
      withFirstLoginSessionToken(
        withUser(
          withCalendarFilter(
            withLoader(
              withNotify(
                withCaseDer(
                  withThemeColor(
                    Header
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
